<div>
  <div class="card-header">
    <div class="title-section">
      <h2 class="header-title">ABC Monedas</h2>
    </div>
    <div class="search-section">
      <div class="button-section">
        <span class="p-input-icon-left search-input">
          <i class="pi pi-search"></i>
          <input
            pInputText
            type="text"
            (input)="dt?.filterGlobal($any($event.target).value, 'contains')"
            placeholder="Buscar..."
            class="p-inputtext-sm"
            [(ngModel)]="valueToSearch"
            appPermissionControl="P108K0001"
          />
        </span>
        <!-- <button mat-flat-button (click)="search()" class="btn-search" [disabled]="!valueToSearch" appPermissionControl="P108B0004">
                    <mat-icon>search</mat-icon>
                    Buscar por clave
                </button> -->
        <button mat-flat-button (click)="abrirModal({})" class="btn-new" appPermissionControl="P108B0001">
          <mat-icon>add</mat-icon>
          Nuevo
        </button>
      </div>
    </div>
  </div>

  <p-table
    #dt
    [value]="dataSource"
    [columns]="columns"
    [paginator]="true"
    [rows]="10"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[10, 15, 20]"
    [scrollable]="true"
    scrollHeight="700px"
    styleClass="p-datatable-gridlines"
    [resizableColumns]="true"
    [autoLayout]="true"
    responsiveLayout="scroll"
    [globalFilterFields]="['moneda', 'descripcion', 'fecha_Ultima', 'factor', 'responsable']"
    currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
    appPermissionControl="P108T0001"
  >
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th *ngFor="let col of columns" [pSortableColumn]="col.field !== 'actions' ? col.field : null" class="th-prime" appPermissionControl="P108C0001">
          {{ col.header }}
          @if(col.field !== 'actions') {
          <p-sortIcon [field]="col.field"></p-sortIcon>
          }
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <tr>
        <td *ngFor="let col of columns" class="td-prime">
          <ng-container [ngSwitch]="col.field">
            <ng-container *ngSwitchCase="'actions'">
              <div class="d-flex gap-2 justify-content-center">
                <button pButton icon="pi pi-eye" class="p-button-rounded p-button-primary p-button-text" (click)="abrirModal(rowData)" appPermissionControl="P108B0002"></button>
                <button pButton icon="pi pi-trash" class="p-button-rounded p-button-danger p-button-text" (click)="deleteMoneda(rowData)" appPermissionControl="P108B0003"></button>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'fecha_Ultima'">
              {{ this._helpers.convertJulianasToGregorianas(rowData.fecha_Ultima) }}
            </ng-container>
            <ng-container *ngSwitchCase="'moneda'">
              <strong>{{ rowData[col.field] }}</strong>
            </ng-container>
            <ng-container *ngSwitchDefault>
              {{ rowData[col.field] }}
            </ng-container>
          </ng-container>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="8" class="text-center td-prime">No hay datos para mostrar</td>
      </tr>
    </ng-template>
  </p-table>
</div>

<app-abc-monedas-form [openModal]="handleModal" [dataModal]="dataModal" (closeModal)="GetABCMonedas()"></app-abc-monedas-form>
